// timeAgo.ts

const capitaliseIfSingleWord = (s: string) =>
    /\s/.test(s) ? s : s.charAt(0).toUpperCase() + s.slice(1);

export function timeAgo(utcMs: number, locale = "en"): string {
    const diffSec = Math.floor((Date.now() - utcMs) / 1000);
    const rtf = new Intl.RelativeTimeFormat(locale, {
        numeric: "auto",
        style: "narrow",
    });

    let out: string;

    if (diffSec < 60) out = rtf.format(-diffSec, "second");
    else if (diffSec < 3600) out = rtf.format(-((diffSec / 60) | 0), "minute");
    else if (diffSec < 86_400)
        out = rtf.format(-((diffSec / 3600) | 0), "hour");
    else if (diffSec < 604_800)
        out = rtf.format(-((diffSec / 86_400) | 0), "day");
    else if (diffSec < 2_592_000)
        out = rtf.format(-((diffSec / 604_800) | 0), "week");
    else out = rtf.format(-((diffSec / 31_536_000) | 0), "year");

    return capitaliseIfSingleWord(out);
}
